<template>
  <div>
    <v-text-field
      v-if="!isDelegationOrderDisabled"
      class="disable"
      :label="$t('components.delegationOrderSelect.label')"
      readonly
      :value="delegationOrderNumber"
      :error-messages="errorMessages"
    >
      <div slot="append-outer" style="width: 104px;" v-if="$store.state.Delegation.readonly !== true">
        <v-btn @click="removeChoice" icon>
          <v-icon class="font-weight-regular">close</v-icon>
        </v-btn>
        <v-btn @click="openDialog" icon>
          <v-icon class="font-weight-regular">fa-list-alt</v-icon>
        </v-btn>
      </div>
    </v-text-field>
    <v-dialog v-model="dialog" persistent max-width="1200px">
      <v-card>
        <v-card-text>
          <v-row align="end" style="margin-bottom: 15px">
            <v-col cols="12"
              ><h2>
                {{ $t("components.delegationOrderSelect.list") }}
              </h2></v-col
            >
            <v-col cols="6"
              >{{ $t("delegation.delegationNewBasedOnDelegationOrder.chooseBaseDelegationOrder") }}<br />
              <span class="font-weight-bold" v-if="isDelegationOrderRequired">{{
                $t("delegation.delegationNewBasedOnDelegationOrder.delegationOrderRequired")
              }}</span>
            </v-col>
            <v-col cols="6">
              <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search" />
            </v-col>
            <v-spacer />
          </v-row>
          <v-data-table :headers="headers" :items="delegationOrders" :search="search" class="elevation-1">
            <template #item="props">
              <tr>
                <td class="text-left">
                  {{ !!props.item.number ? props.item.number : $t("components.documentNumber.notSet") }}
                </td>
                <td class="text-left">
                  {{ !!props.item.delegated_user ? props.item.delegated_user : $t("global.notSet") }}
                </td>
                <td class="text-left">
                  {{ !!props.item.date_start ? props.item.date_start : $t("global.notSet") }}
                </td>
                <td class="text-left">
                  {{ !!props.item.date_end ? props.item.date_end : $t("global.notSet") }}
                </td>
                <td class="justify-center layout px-0">
                  <v-tooltip bottom>
                    <template #activator="{on}">
                      <v-btn text icon v-on="on" @click="previewDelegationOrder(props.item)">
                        <v-icon>search</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("delegation.delegationNewBasedOnDelegationOrder.previewDelegationOrderDetails") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template #activator="{on}">
                      <v-btn
                        :disabled="!((props.item.delegationId == null || props.item.delegationId === delegationId) && props.item.status === 3)"
                        text
                        icon
                        v-on="on"
                        @click="chooseDelegationOrder(props.item)"
                      >
                        <v-icon>send</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="(props.item.delegationId == null || props.item.delegationId === delegationId) && props.item.status === 3">{{
                      $t("global.choose")
                    }}</span>
                    <span v-else-if="props.item.status !== 3">{{ $t("delegation.delegationNewBasedOnDelegationOrder.onlyAcceptedOrders") }}</span>
                    <span v-else>{{ $t("delegation.delegationNewBasedOnDelegationOrder.alreadyCreatedSettlement") }}</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <v-alert color="error" icon="warning">
                {{ $t("delegation.delegationNewBasedOnDelegationOrder.noData") }}
              </v-alert>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="blue darken-1" text @click.native="dialog = false">{{ $t("global.close") }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import downloadInNewWindow from "../../repository/downloadFile";

export default {
  name: "DelegationOrderSelect",
  props: {
    delegationOrderId: {
      required: true
    },
    delegationOrderNumber: {
      required: true
    },
    delegationId: {
      default: null
    },
    errorMessages: {
      default: null
    }
  },
  data: () => ({
    delegationOrders: [],
    search: "",
    dialog: false
  }),
  computed: {
    headers() {
      return [
        { text: this.$t("delegation.number"), value: "number" },
        { text: this.$t("delegation.delegated"), value: "delegated_user" },
        { text: this.$t("delegation.startDate"), value: "date_start" },
        { text: this.$t("delegation.endDate"), value: "date_end" },
        { text: "", value: "actions", sortable: false }
      ];
    },
    isDelegationOrderRequired() {
      let userProperty = this.$store.getters["userProperties"];
      return userProperty.system_settings.delegation_order_type === 3;
    },
    isDelegationOrderDisabled() {
      let userProperty = this.$store.getters["userProperties"];
      return userProperty.system_settings.delegation_order_type === 1;
    }
  },
  methods: {
    previewDelegationOrder: function(item) {
      downloadInNewWindow("delegation-order/document-preview?id=" + item.id);
    },
    chooseDelegationOrder: function(item) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("delegation.delegationNewBasedOnDelegationOrder.confirm.content"),
        title: this.$t("delegation.delegationNewBasedOnDelegationOrder.confirm.title")
      });
      result.then(() => {
        this.$emit("update:delegationOrderId", item.id);
        this.$emit("update:delegationOrderNumber", item.number);
        this.dialog = false;
      });
    },
    goBack: function() {},
    openDialog() {
      this.dialog = true;
    },
    removeChoice() {
      this.$emit("update:delegationOrderId", null);
      this.$emit("update:delegationOrderNumber", null);
    }
  },
  created() {
    this.axios({ url: "delegation/get-available-delegation-order" }).then(resp => {
      this.delegationOrders = resp.data;

      //
      // for (let index in resp.data) {
      //     this.delegationOrders.push({number: resp.data. resp.data[index].id, text: resp.data[index].text});
      // }
      // object.loading = false;
    });
  }
};
</script>

<style scoped></style>
